import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/Logo";
import { NAV_LINKS, COURSES, STUDENT_LOGIN_URL } from "@/lib/site";

export const Footer = () => (
  <footer className="relative mt-24 overflow-hidden bg-ink text-cream" data-testid="site-footer">
    <div className="container-x grid gap-12 py-16 md:grid-cols-12">
      <div className="md:col-span-5">
        <div className="inline-block rounded-2xl bg-cream px-4 py-2">
          <Logo testid="footer-logo" />
        </div>
        <p className="mt-6 max-w-sm font-heading text-2xl leading-snug">Explore. Question. Create the Future.</p>
        <p className="mt-3 max-w-sm text-cream/80">
          Minds United for Curiosity, Creativity &amp; Innovation. Inquiry-based learning for Years 5–10 across New Zealand.
        </p>
      </div>
      <nav aria-label="Footer" className="md:col-span-3">
        <h2 className="font-heading text-lg text-cream">Explore</h2>
        <ul className="mt-4 space-y-2">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="text-cream/85 hover:text-lemon transition-colors" data-testid={`footer-${l.testid}`}>{l.label}</Link>
            </li>
          ))}
          <li>
            <a href={STUDENT_LOGIN_URL || "#"} target="_blank" rel="noopener noreferrer" className="text-cream/85 hover:text-lemon transition-colors" data-testid="footer-student-login">
              Student Login<span className="sr-only"> (opens in a new tab)</span>
            </a>
          </li>
        </ul>
      </nav>
      <div className="md:col-span-4">
        <h2 className="font-heading text-lg text-cream">Courses</h2>
        <ul className="mt-4 space-y-2">
          {COURSES.map((c) => (
            <li key={c.slug}>
              <Link to={`/courses#${c.slug}`} className="text-cream/85 hover:text-lemon transition-colors" data-testid={`footer-course-${c.slug}`}>{c.title}</Link>
            </li>
          ))}
        </ul>
        <Link to="/contact#enquire" className="mt-6 inline-flex rounded-full bg-lemon px-5 py-2.5 font-bold text-ink hover:bg-lemon-deep transition-colors" data-testid="footer-enquire">
          Send an enquiry
        </Link>
      </div>
    </div>
    <div className="border-t border-cream/15">
      <div className="container-x flex flex-col gap-2 py-6 text-sm text-cream/70 sm:flex-row sm:justify-between">
        <p>© {new Date().getFullYear()} MUCCI Academy. All rights reserved.</p>
        <p>Aotearoa New Zealand</p>
      </div>
    </div>
  </footer>
);
